"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const o=(r,e)=>!!r.error&&(r.touched||e>0);exports.getHasError=o;
